import AbstractService from "./abstract.service"
import UserAccountsTransformer, { baseUri } from "@/transformers/userAccount.transformer"

class UserAccountsService extends AbstractService {
  constructor() {
    super({ baseUri, transformer: UserAccountsTransformer })
  }

  async setAccessOrRole(payload) {
    return await this.patch(`${this.baseUri}/${payload.uuid}`, {
      needsAuth: true,
      payload: {
        group: payload.group
      }
    })
  }
  async sendInvitation(payload) {
    return await this.post(this.baseUri, {
      payload: {
        invitation: {
          name: payload.email.split("@").shift(),
          lastName: "",
          email: payload.email
        },
        group: payload.group
      },
      needsAuth: true
    })
  }
  async revokeInvitation(uuid) {
    return this.delete(`${this.baseUri}/${uuid}`, {
      needsAuth: true
    })
  }
}

const userAccountsService = new UserAccountsService()
export default userAccountsService
